


export enum ReportType {
	reducedReport = 'reducedReport',
	redatedReport = 'redatedReport',
	undeliveredReport = 'undeliveredReport',
}